/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   ____  ____   ___  
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| |  _ \|  _ \ / _ \ 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || |  | |_) | |_) | | | |
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |  |  __/|  _ <| |_| |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___| |_|   |_| \_\\___/ 
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI Dashboard PRO - v1.0.0
=========================================================

* Product Page: https://www.horizon-ui.com/pro/
* Copyright 2022 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import { Flex, Grid, GridItem } from '@chakra-ui/react';
import StrategiesPanel from './components/StrategiesPanel';
import TradeLogicPanel from './components/TradeLogicPanel';
import TradeLogicCategories from './components/TradeLogicCategories';
import { useData } from 'services/data/DataProvider';
import { useEffect, useState } from 'react';
import { newUserTradeLogic, TradeLogic, UserTradeLogic } from '../trades/variables/types';
// Custom components


export default function Default() {


  // Chakra Color Mode
  /*const paleGray = useColorModeValue('#DFE6F6', 'whiteAlpha.100');
  const bgcolor = useColorModeValue('white', 'navy.900');
  const textColorSecondary = useColorModeValue('secondaryGray.700', 'secondaryGray.500');
  const textColor = useColorModeValue('secondaryGray.900', 'white');*/

  const { usertrades, defaultcurrency } = useData();
  const [usedLogic, setUsedLogic] = useState<UserTradeLogic>(newUserTradeLogic());

  useEffect(() => {
    if (usertrades.length > 0) {
      updateValues();
    }
  }, [usertrades])

  const updateValues = () => {

    let u_logic: UserTradeLogic = newUserTradeLogic();

    for (let tr of usertrades) {
      if (tr.trade_logic && tr.trade_logic.length > 0) {

        let logic: TradeLogic = tr.trade_logic[0];

        if (logic.market_condition !== '') {
          if (!u_logic.market_condition.includes(logic.market_condition)) {
            u_logic.market_condition.push(logic.market_condition);
          }
        }
        if (logic.key_level !== '') {
          if (!u_logic.key_level.includes(logic.key_level)) {
            u_logic.key_level.push(logic.key_level);
          }
        }
        if (logic.htf !== '') {
          if (!u_logic.htf.includes(logic.htf)) {
            u_logic.htf.push(logic.htf);
          }
        }
        if (logic.htf_trend !== '') {
          if (!u_logic.htf_trend.includes(logic.htf_trend)) {
            u_logic.htf_trend.push(logic.htf_trend);
          }
        }
        if (logic.etf !== '') {
          if (!u_logic.etf.includes(logic.etf)) {
            u_logic.etf.push(logic.etf);
          }
        }
        if (logic.entry !== '') {
          if (!u_logic.entry.includes(logic.entry)) {
            u_logic.entry.push(logic.entry);
          }
        }
        if (logic.stop !== '') {
          if (!u_logic.stop.includes(logic.stop)) {
            u_logic.stop.push(logic.stop);
          }
        }
        if (logic.target !== '') {
          if (!u_logic.target.includes(logic.target)) {
            u_logic.target.push(logic.target);
          }
        }
      }
    }

    setUsedLogic(u_logic);

  }

  return (
    <Flex direction={{ base: 'column', xl: 'row' }} pt={{ base: '130px', md: '80px', xl: '80px' }}>

      <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' , xl: 'repeat(4, 1fr)' }} gap={6} w='100%' mt='20px' minH={'700px'}>
        <GridItem colSpan={{ base: 1, md: 2 }} rowSpan={1}>
          <TradeLogicPanel usedlogic={usedLogic} />
        </GridItem>
        <GridItem colSpan={1} rowSpan={1}>
          <TradeLogicCategories usedlogic={usedLogic} />
        </GridItem>
        <GridItem colSpan={1} rowSpan={1}>
          <StrategiesPanel />
        </GridItem>
      </Grid>


    </Flex>
  );
}
